module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('nav', {
    staticClass: "navbar navbar-expand-lg navbar-light container-fluid navbar-admin bg-success text-white"
  }, [_vm._m(0), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.home
    }
  }, [_vm._v("首頁")]), _vm._v("\n      \n    "), (_vm.user !== null || _vm.user !== undefined) ? _c('span', {
    attrs: {
      "id": "greeting"
    }
  }, [_vm._v(_vm._s(_vm.GreetingMsg) + ", \n      "), (_vm.user.first_name !== null && _vm.user.last_name !== null) ? _c('span', [_vm._v(_vm._s(_vm.user.last_name) + _vm._s(_vm.user.first_name))]) : _c('span', [_vm._v(_vm._s(_vm.user.username))]), _vm._v(" "), (_vm.user.title !== null) ? _c('span', [_vm._v(_vm._s(_vm.user.title.name))]) : _vm._e()]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    attrs: {
      "id": "navbarSupportedContent"
    }
  }, [_c('ul', {
    staticClass: "navbar-nav ml-auto"
  }, _vm._l((_vm.navs), function(nav) {
    return (Object.keys(nav.child).length > 0) ? _c('li', {
      staticClass: "nav-item dropdown"
    }, [(nav.privilege) ? _c('div', {
      staticClass: "nav-link dropdown-toggle",
      attrs: {
        "role": "button",
        "data-toggle": "dropdown",
        "aria-haspopup": "true",
        "aria-expanded": "false"
      }
    }, [_vm._v("\n            " + _vm._s(nav.name) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "dropdown-menu",
      attrs: {
        "aria-labelledby": "navbarDropdown"
      }
    }, _vm._l((nav.child), function(child) {
      return (child.privilege) ? _c('router-link', {
        key: child.name,
        staticClass: "dropdown-item",
        attrs: {
          "to": {
            name: child.url
          }
        }
      }, [_vm._v(_vm._s(child.name))]) : _vm._e()
    }), 1)]) : _c('li', {
      staticClass: "nav-item"
    }, [(nav.privilege) ? _c('router-link', {
      staticClass: "nav-link",
      attrs: {
        "to": {
          name: nav.url
        }
      }
    }, [_vm._v("\n            " + _vm._s(nav.name) + "\n          ")]) : _vm._e()], 1)
  }), 0)]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    on: {
      "click": _vm.logout
    }
  }, [_vm._v("登出")])]), _vm._v(" "), _c('div', {
    staticClass: "container-fluid main-container"
  }, [_c('locked-mask', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pageShouldChecked && _vm.frontendLogined),
      expression: "pageShouldChecked && frontendLogined"
    }]
  }), _vm._v(" "), (_vm.$route.name === 'Admin') ? _c('div', {
    class: {
      'admin-hero': true, 'admin-blur': (_vm.pageShouldChecked && _vm.frontendLogined)
    }
  }, [_c('h1', {
    staticClass: "display-4"
  }, [_vm._v("歡迎使用")]), _vm._v(" "), _c('h1', {
    staticClass: "display-4 bg-info text-white rounded"
  }, [_vm._v("彰化台61科技執法後台管理系統")]), _vm._v(" "), (_vm.department == 'Admin') ? _c('div', [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "custom-control custom-radio"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.fixedLinkCode4SuperUser),
      expression: "fixedLinkCode4SuperUser"
    }],
    staticClass: "custom-control-input",
    attrs: {
      "type": "radio",
      "id": "defaultGroupExample1",
      "value": "B01"
    },
    domProps: {
      "checked": _vm._q(_vm.fixedLinkCode4SuperUser, "B01")
    },
    on: {
      "change": function($event) {
        _vm.fixedLinkCode4SuperUser = "B01"
      }
    }
  }), _vm._v(" "), _vm._m(3)])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    class: {
      'admin-blur': (_vm.pageShouldChecked && _vm.frontendLogined)
    }
  }, [_c('router-view')], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "container-fluid main-footer bg-warning text-dark"
  }, [_c('p', [_c('small', {
    staticClass: "font-weight-bold"
  }, [_vm._v("Copyright © EST")]), _vm._v(" "), _c('small', {
    staticClass: "float-right font-weight-bold"
  }, [_vm._v("version:" + _vm._s(_vm.version))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "navbar-brand mb-0 h2",
    attrs: {
      "href": "#"
    }
  }, [_c('img', {
    staticClass: "navbar-brand",
    attrs: {
      "src": require("../assets/img/changhua.png"),
      "alt": "changhua-logo",
      "height": "60px"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggler",
    staticStyle: {
      "margin-left": "auto",
      "margin-right": "1rem"
    },
    attrs: {
      "type": "button",
      "data-toggle": "collapse",
      "data-target": "#navbarSupportedContent",
      "aria-controls": "navbarSupportedContent",
      "aria-expanded": "false",
      "aria-label": "Toggle navigation"
    }
  }, [_c('span', {
    staticClass: "navbar-toggler-icon"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h3', [_c('kbd', [_vm._v("查詢地點選擇 ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', {
    staticClass: "custom-control-label",
    attrs: {
      "for": "defaultGroupExample1"
    }
  }, [_c('h5', [_vm._v("台61彰化段(北上)")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-11c9c97e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = 1392
// module chunks = 1